import { Integration } from '@sentry/core';
import * as Sentry from '@sentry/react';
import { DummyMonitoring, MonitoringInstance } from '@xometry/ui';
import { ENV_API_ENDPOINT, ENV_CUSTOM_ENV, RELEASE, SENTRY_DSN } from 'constants/env';

import { createBeforeSend } from './monitoring.utils';

export const getMonitoringClient = (): Promise<MonitoringInstance> =>
  import('./Sentry')
    .then(
      (r) =>
        new r.SentryMonitoring({
          production: ENV_CUSTOM_ENV === 'production',
          environment: ENV_CUSTOM_ENV,
          release: RELEASE,
          dsn: SENTRY_DSN,
          configure: (draft) => {
            const integrations = (
              Array.isArray(draft.integrations) ? [...draft.integrations] : [draft.integrations]
            ) as Integration[];

            const beforeSend = draft.beforeSend;

            integrations.push(
              // https://docs.sentry.io/platforms/javascript/session-replay/privacy/#privacy-configuration
              Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: true,
                networkDetailAllowUrls: [`${ENV_API_ENDPOINT}/oms/graphql`],
              }),
            );

            return {
              ...draft,
              dist: draft.release,
              integrations: integrations as typeof draft.integrations,
              beforeSend: createBeforeSend(beforeSend),
              tracePropagationTargets: [ENV_API_ENDPOINT],
            };
          },
        }),
    )
    .catch(() => new DummyMonitoring());
